
import { HelpCircle } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from "@/components/ui/tooltip";
import { useThemeConfig } from "@/components/ui/theme-config-provider";

interface HelpButtonProps {
  onClick: () => void;
  className?: string;
  size?: "default" | "sm" | "lg" | "icon";
  variant?: "ghost" | "outline" | "default";
  tooltip?: string;
  /**
   * Choose which theme color should be applied to the icon.
   * - "primary": use `theme.primaryColor` (default)
   * - "text": use `theme.textPrimaryColor`
   */
  color?: "primary" | "text";
  style?: React.CSSProperties;
}

const HelpButton = ({
  onClick,
  className = "",
  size = "icon",
  variant = "ghost",
  tooltip = "Visualizza guida",
  color = "primary",
  style,
}: HelpButtonProps) => {
  const { theme } = useThemeConfig();
  const iconColor = color === "text" ? theme.textPrimaryColor : theme.primaryColor;
  
  return (
    <TooltipProvider>
      <Tooltip>
        <TooltipTrigger asChild>
          <Button 
            variant={variant} 
            size={size} 
            onClick={onClick} 
            className={`rounded-full ${className}`}
            aria-label="Visualizza guida"
          style={{
            borderRadius: '9999px',
            ...(variant === "default"
              ? {
                  backgroundColor: theme.primaryColor || '#9b87f5',
                  color: theme.textPrimaryColor
                }
              : {
                  color: iconColor
                }),
            ...style
          }}
        >
            <HelpCircle className={`${size === "icon" ? "h-5 w-5" : "h-4 w-4"}`} />
          </Button>
        </TooltipTrigger>
        <TooltipContent>
          <p>{tooltip}</p>
        </TooltipContent>
      </Tooltip>
    </TooltipProvider>
  );
};

export default HelpButton;
